import React, { useState } from 'react'
import { warningAlert } from 'pages/components/SweetAlert';
import { successAlert } from 'pages/components/SweetAlert';
import { Button, Card, CardBody, CardFooter, CardHeader, Form, FormGroup, Input, Modal } from 'reactstrap'


const ModalStockMinimo = ({ModaladdStockMinimo, setModaladdStockMinimo, StockMinimo, setStockMinimo,agregarTmConStockMinimo}) => {
    const [Alert, setAlert] = useState(null);
    const [Error, setError] = useState({})
    
    const cambiarStockMinimo = (e)=> {
        setStockMinimo(e.target.value)
    }
    const validarMinimo = () => {
        if (StockMinimo <=0) {
            setError({message : "El Stock Minimo debe ser mayor a 0!"})
            return false
        }
        return true
    }

    const Confirmar = async() =>{
        if(validarMinimo() === true) {
            agregarTmConStockMinimo()
            setModaladdStockMinimo(false)
        }else{
            setStockMinimo(0)
            warningAlert(setAlert, `${Error.message}`)
        }
    }

  return (
    <>
        {Alert}
        <Modal
        className="modal-dialog-centered"
        size="sm"
        isOpen={ModaladdStockMinimo}
        toggle={() => setModaladdStockMinimo(false)}
        >
        <div>
        <Card>
            <CardHeader className="pb-3">
            <div className="text-center"><b>Stock Minimo:</b>
            <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setModaladdStockMinimo(false)}
        >
            <span aria-hidden={true}>×</span>
        </button>
            </div>
            </CardHeader>  
            <CardBody>
            <div className=" mt-5 mb-3">
            <Form role="form">
            <FormGroup>
                <Input
                    type="number"
                    onChange={cambiarStockMinimo}
                    />
            </FormGroup>
            </Form>                     
            </div>                    
            </CardBody>
            <CardFooter>
                <div className="text-center">
                <Button
                    className=""
                    color="primary"
                    type="button"
                    onClick={()=>Confirmar()}
                    
                    >
                    Confirmar
                </Button>
            
                <Button
                    color="secondary"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => setModaladdStockMinimo(false)}
                >
                    Cerrar
                </Button>                    
                </div>
                </CardFooter>                
        </Card>
        </div>
        </Modal></>
  )
}

export default ModalStockMinimo